export const trainingAgendaTemplates = [
  {
    type: '精研班',
    intro: '国医大师亲临授课，聚焦辨证思路与核心方药，结合真实医案与临床带教，小班精研、深度互动。',
    items: [
      { time: '08:30 - 09:00', title: '签到入场 · 领取学习资料', speaker: '会务组' },
      { time: '09:00 - 09:20', title: '开班致辞 · 主办医院领导', speaker: '主办医院领导' },
      { time: '09:20 - 11:00', title: '专题授课：辨治思路与核心方药', speaker: '国医大师' },
      { time: '11:00 - 12:00', title: '典型医案解析与组方加减', speaker: '国医大师' },
      { time: '12:00 - 13:30', title: '午休 · 自助午餐', speaker: '会务组' },
      { time: '13:30 - 15:30', title: '分组研讨与临床带教', speaker: '名老中医团队' },
      { time: '15:30 - 16:30', title: '疑难病例现场答疑', speaker: '授课专家团' },
      { time: '16:30 - 17:00', title: '结业总结 · 拜师师承与临床带教', speaker: '主办医院领导' },
    ],
  },
  {
    type: '研修班',
    intro: '围绕重点病种与学科前沿系统授课，涵盖诊疗规范、中西医结合路径与临床案例工作坊，学用结合。',
    items: [
      { time: '08:30 - 09:00', title: '签到入场', speaker: '会务组' },
      { time: '09:00 - 09:15', title: '开班致辞', speaker: '主办医院领导' },
      { time: '09:15 - 11:00', title: '专题一：诊疗规范与最新进展', speaker: '学科带头人' },
      { time: '11:00 - 12:00', title: '专题二：中西医结合诊疗路径', speaker: '主讲专家' },
      { time: '12:00 - 13:30', title: '午休 · 自助午餐', speaker: '会务组' },
      { time: '13:30 - 15:30', title: '临床案例工作坊', speaker: '主讲专家' },
      { time: '15:30 - 16:45', title: '互动答疑与经验交流', speaker: '授课专家团' },
      { time: '16:45 - 17:00', title: '总结致辞 · 拜师师承与临床带教', speaker: '主办医院领导' },
    ],
  },
  {
    type: '培训班',
    intro: '以适宜技术为主线，理论精讲与现场示范相结合，分组实操练习并由专家逐一点评考核。',
    items: [
      { time: '09:00 - 09:20', title: '开班致辞 · 培训安排说明', speaker: '主办医院领导' },
      { time: '09:20 - 11:00', title: '技术理论精讲', speaker: '主讲专家' },
      { time: '11:00 - 12:00', title: '现场示范教学', speaker: '主讲专家' },
      { time: '12:00 - 13:30', title: '午休 · 自助午餐', speaker: '会务组' },
      { time: '13:30 - 16:00', title: '分组实操练习', speaker: '带教老师' },
      { time: '16:00 - 16:30', title: '操作考核与专家点评', speaker: '专家评审团' },
      { time: '16:30 - 17:00', title: '结业总结 · 拜师师承与临床带教', speaker: '主办医院领导' },
    ],
  },
  {
    type: '培训',
    intro: '聚焦特色技术与临床实用方法，理论讲授与操作演练并重，帮助学员快速掌握并能落地应用。',
    items: [
      { time: '09:00 - 09:20', title: '签到与开班说明', speaker: '会务组' },
      { time: '09:20 - 11:00', title: '特色技术理论精讲', speaker: '主讲专家' },
      { time: '11:00 - 12:00', title: '现场示范与要点解析', speaker: '主讲专家' },
      { time: '12:00 - 13:30', title: '午休 · 自助午餐', speaker: '会务组' },
      { time: '13:30 - 16:00', title: '分组实操与带教指导', speaker: '带教老师' },
      { time: '16:00 - 16:30', title: '点评总结 · 拜师师承与临床带教', speaker: '主办医院代表' },
    ],
  },
  {
    type: '研讨会',
    intro: '汇聚多学科专家与产业伙伴，围绕前沿议题展开主题报告与圆桌对话，共探中西医结合新路径。',
    items: [
      { time: '09:00 - 09:30', title: '签到入场', speaker: '会务组' },
      { time: '09:30 - 10:00', title: '开幕致辞', speaker: '主办单位领导' },
      { time: '10:00 - 12:00', title: '主题报告：前沿进展与实践', speaker: '特邀专家' },
      { time: '12:00 - 13:30', title: '午休 · 自助午餐', speaker: '会务组' },
      { time: '13:30 - 15:30', title: '圆桌对话 · 多学科研讨', speaker: '与会专家团' },
      { time: '15:30 - 17:00', title: '自由交流与合影', speaker: '全体参会人员' },
    ],
  },
];

export const trainingSpeakers = [
  {
    id: 1,
    name: '李显筑',
    title: '全国名老中医 · 主任医师',
    hospital: '黑龙江省中医药科学院',
    field: '内分泌代谢病',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20distinguished%20senior%20Chinese%20male%20endocrinology%20professor%20in%20a%20white%20coat%20with%20gold-rimmed%20glasses%2C%20clean%20soft%20warm%20ivory%20studio%20background%2C%20professional%20medical%20headshot%2C%20trustworthy%20confident%20expression%2C%20soft%20even%20lighting%2C%20high%20detail&width=400&height=400&seq=train-spk-11&orientation=squarish',
  },
  {
    id: 2,
    name: '赵家军',
    title: '主任医师 · 教授',
    hospital: '山东省立医院',
    field: '内分泌 · 糖尿病',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20senior%20Chinese%20male%20endocrinology%20specialist%20in%20a%20white%20coat%20and%20tie%2C%20clean%20warm%20neutral%20studio%20background%2C%20professional%20medical%20portrait%2C%20calm%20authoritative%20expression%2C%20soft%20studio%20light%2C%20high%20detail&width=400&height=400&seq=train-spk-12&orientation=squarish',
  },
  {
    id: 3,
    name: '杨晓晖',
    title: '主任医师 · 教授',
    hospital: '北京中医药大学东直门医院',
    field: '内分泌 · 糖尿病并发症',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle%20aged%20Chinese%20male%20internal%20medicine%20doctor%20in%20a%20white%20coat%2C%20clean%20light%20warm%20beige%20studio%20background%2C%20professional%20medical%20headshot%2C%20steady%20friendly%20expression%2C%20soft%20even%20lighting%2C%20high%20detail&width=400&height=400&seq=train-spk-13&orientation=squarish',
  },
  {
    id: 4,
    name: '王新陆',
    title: '国医大师 · 主任医师',
    hospital: '山东中医药大学',
    field: '中医内科 · 脑病',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20venerable%20senior%20Chinese%20male%20traditional%20medicine%20master%20in%20a%20white%20coat%2C%20clean%20soft%20ivory%20studio%20background%2C%20respectful%20professional%20portrait%2C%20kind%20wise%20smile%2C%20soft%20window%20light%2C%20high%20detail&width=400&height=400&seq=train-spk-14&orientation=squarish',
  },
  {
    id: 5,
    name: '王中琳',
    title: '主任医师 · 教授',
    hospital: '山东中医药大学附属医院',
    field: '中医脑病',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20composed%20Chinese%20male%20neurology%20professor%20of%20traditional%20medicine%20in%20a%20white%20coat%2C%20clean%20light%20neutral%20studio%20background%2C%20professional%20medical%20headshot%2C%20thoughtful%20expression%2C%20soft%20studio%20light%2C%20high%20detail&width=400&height=400&seq=train-spk-15&orientation=squarish',
  },
  {
    id: 6,
    name: '齐向华',
    title: '主任医师 · 教授',
    hospital: '山东中医药大学附属医院',
    field: '脉诊 · 中医内科',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20senior%20Chinese%20male%20traditional%20medicine%20pulse%20diagnosis%20expert%20in%20a%20white%20coat%2C%20clean%20warm%20beige%20studio%20background%2C%20professional%20medical%20portrait%2C%20calm%20focused%20expression%2C%20soft%20even%20lighting%2C%20high%20detail&width=400&height=400&seq=train-spk-16&orientation=squarish',
  },
  {
    id: 7,
    name: '李佃贵',
    title: '国医大师 · 主任医师',
    hospital: '河北省中医院',
    field: '脾胃病 · 浊毒理论',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20venerable%20senior%20Chinese%20male%20gastroenterology%20master%20of%20traditional%20medicine%20in%20a%20white%20coat%2C%20clean%20soft%20ivory%20studio%20background%2C%20respectful%20professional%20portrait%2C%20kind%20confident%20smile%2C%20soft%20window%20light%2C%20high%20detail&width=400&height=400&seq=train-spk-17&orientation=squarish',
  },
  {
    id: 8,
    name: '杨晋翔',
    title: '主任医师 · 教授',
    hospital: '北京中医药大学东直门医院',
    field: '脾胃病 · 肝胆病',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20senior%20Chinese%20male%20digestive%20medicine%20professor%20of%20traditional%20medicine%20in%20a%20white%20coat%2C%20clean%20light%20warm%20studio%20background%2C%20professional%20medical%20headshot%2C%20steady%20expression%2C%20soft%20even%20lighting%2C%20high%20detail&width=400&height=400&seq=train-spk-18&orientation=squarish',
  },
  {
    id: 9,
    name: '刘汶',
    title: '主任医师 · 教授',
    hospital: '首都医科大学附属北京中医医院',
    field: '消化系统疾病',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20senior%20Chinese%20male%20gastroenterology%20doctor%20in%20a%20white%20coat%20with%20glasses%2C%20clean%20soft%20neutral%20studio%20background%2C%20professional%20medical%20portrait%2C%20calm%20reassuring%20expression%2C%20soft%20studio%20light%2C%20high%20detail&width=400&height=400&seq=train-spk-19&orientation=squarish',
  },
  {
    id: 10,
    name: '韩晶岩',
    title: '教授 · 博士生导师',
    hospital: '北京大学医学部',
    field: '中西医结合 · 微循环',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20distinguished%20Chinese%20male%20medical%20research%20professor%20in%20a%20white%20coat%20with%20glasses%2C%20clean%20light%20grey%20studio%20background%2C%20professional%20academic%20portrait%2C%20thoughtful%20confident%20expression%2C%20soft%20even%20lighting%2C%20high%20detail&width=400&height=400&seq=train-spk-20&orientation=squarish',
  },
];

export const trainingNotices = [
  '本培训为线下集中授课，报名成功后请按通知时间准时到场签到。',
  '请携带本人身份证及执业医师资格证（或相关从业证明）以便核验。',
  '培训期间统一提供教材与午餐，交通及住宿费用由学员自理。',
  '完成全部课程并通过考核者，可纳入拜师师承、临床带教等后续人才培养环节。',
  '名额有限，以报名先后顺序录取，满员即止，如有变动请提前联系会务组。',
];